import { IonButtons, IonPage, IonTitle, IonToolbar, useIonViewWillEnter, useIonViewWillLeave } from "@ionic/react";
import { memo, 
  experimental_useEffectEvent as useEffectEvent, useEffect, useRef, 
  useState} from "react";

import { useSetActivePage } from "#/features/auth/AppContext";
import AppHeader from "#/features/shared/AppHeader";
import FeedContent from "#/routes/pages/shared/FeedContent";
import { useAppSelector } from "#/store";
import { customClientSelector } from "#/features/auth/authSelectors";
import { PersonView } from "#/features/user/userTypes";
import CuratorsList from "./CuratorsList";
import { useHeader } from "#/core/HeaderContext";
import AppTitle from "#/features/shared/AppTitle";

export default function CuratorsPage() {
  return <CuratorsPageContent />;
}

const CuratorsPageContent = memo(function CuratorsPageContent() {
  const pageRef = useRef<HTMLElement>(null);
  const client = useAppSelector(customClientSelector);
  const { setHeader } = useHeader();
  const [curators, setCurators] = useState<PersonView[]>();

  async function update() {
    try {
      const { list } = await client.getCurators();
      setCurators(list);
    } catch (error) {
      console.error('curators fetch error', error);
    }
  }

  const updateEvent = useEffectEvent(update);

  useEffect(() => {
    updateEvent();
  }, [client]);  
  
  useSetActivePage(pageRef);

  useIonViewWillEnter(() => {
    setHeader({
      children: (
        <AppTitle>Curators</AppTitle>
      )
    })
  });
  
  useIonViewWillLeave(() => setHeader({}));

  return (
    <>
      <IonPage ref={pageRef}>
        <FeedContent>
          <CuratorsList curators={curators ?? []} />
        </FeedContent>
      </IonPage>
    </>
  );
});
